var React = require('react');

function Dollar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m 145,312 c -2,69 31,100 104,102 78,1 113,-34 109,-101 -6,-58 -62,-73 -106,-79 -48,-17 -99,-25 -99,-95 0,-48 32,-79 99,-78 60,0 97,25 96,84","style":{"fill":"none","stroke":"#9b9b9b","strokeWidth":"40"},"key":0}),React.createElement("path",{"d":"m 250,15 0,470","style":{"stroke":"#9b9b9b","strokeWidth":"30"},"key":1})]);
}

Dollar.defaultProps = {"version":"1.1","viewBox":"0 0 500 500","width":"24","height":"24"};

module.exports = Dollar;

Dollar.default = Dollar;
